const routes = {
  "/": "Home",
  "/courses": "Navigation_Courses",
  "/studentprofile": "Navigation_StudentProfile",
  "/superuser/schools": "Navigation_Superuser_Schools",
  "/superuser/schools/teachers": "Navigation_Superuser_Teachers",
  "/superuser/schools/students": "Navigation_Superuser_Students",
  "/superuser/schools/classes": "Navigation_Superuser_Classes",
  "/superuser/schools/programmes": "Navigation_Superuser_Programs",
  "/superuser/schools/classes/classoverview": "Navigation_Superuser_Class_Overview",
  "/superuser/courses": "Navigation_Superuser_Courses",
  "/superuser/courses/coursemodules": "Navigation_Superuser_CourseModules",
  "/superuser/courses/modules": "Navigation_Superuser_Modules",
  "/superuser/courses/licenses": "Navigation_Superuser_Licenses",
  "/superuser/invoicehistory": "Navigation_Teacher_Invoice_History",
  "/superuser/users": "Navigation_Superuser_Users",
  "/teacher/schoolview": "Navigation_Teacher_School",
  "/teacher/schoolview/programmeview/:id": "Navigation_Teacher_Program",
  "/teacher/schoolview/programmeview/:id/classview/:id": "Navigation_Teacher_Class",
  "/teacher/schoolview/programmeview/:id/classview/:id/courses": "Navigation_Teacher_Result_Module",
  "/teacher/schoolview/programmeview/:id/classview/:id/teacherview": "Navigation_Teacher_Teacher",
  "/teacher/schoolview/programmeview/:id/classview/:id/studentview/:id": "Navigation_Teacher_Class_Student",
  "/teacher/studentview/:id": "Navigation_Teacher_Class_Student",
  "/teacher/shop": "Navigation_Teacher_Shop",
  "/teacher/classes": "Navigation_Teacher_Classes",
  "/teacher/students": "Navigation_Teacher_Students",
  "/teacher/students/createstudent": "Navigation_Teacher_Students_Create",
  "/teacher/shop/confirmed": "Navigation_Teacher_ConfirmedOrder",
  "/teacher/courseview": "Navigation_Teacher_CoursesView",
  "/teacher/courseview/moduleResults": "Navigation_Teacher_Result_Module",
  "/teacher/courseview/results": "Navigation_Teacher_Results",
  "/teacher/courseview/courses": "Navigation_Teacher_Courses",
  "/teacher/courseview/courses/results": "Navigation_Teacher_Results",
  "/teacher/courseview/courses/moduleresults": "Navigation_Teacher_Result_Module",
  "/teacher/courseview/results/moduleResults": "Navigation_Teacher_Result_Module", 
  "/teacher/invoicehistory": "Navigation_Teacher_Invoice_History",
  "/teacher/programmeview/:id/classview/:id/studentview/:id/:studentName" : "Navigation_Teacher_Student_new",
  "/teacher/aboutUs" : "Navigation_Teacher_AboutUs",
  "/teacher/notifications" : "Navigation_Notifications",
  "/superuser/notifications" : "Navigation_Notifications",
  "/superuser/licenses" : "Navigation_Administration_Licenses"
};

export default routes;
